import { scrollToElement } from 'telia-front-react';
import { resolvePrices } from './TvComparisonPriceUtil';
const DEFAULT_VISIBLE_APPS_COUNT = 10;
const NETFLIX_IDENTIFIER = 'NETFLIX';
const HBO_IDENTIFIER = 'HBO';
const INSPIRA_IDENTIFIER = 'FILMIRIIUL';
const FOX_IDENTIFIER = 'FOX';
const NATGEO_IDENTIFIER = 'NATGEO';
const GO3_IDENTIFIER = 'GO3';
const NETFLIX_RED = '#E50914';
export const APP_NAMES = [NETFLIX_IDENTIFIER, GO3_IDENTIFIER, HBO_IDENTIFIER, INSPIRA_IDENTIFIER, FOX_IDENTIFIER, NATGEO_IDENTIFIER];
export const createAppsGroup = ({ apps, labelKey, translate, isAllShown, filterActions, shownItemsCount }) => {
    const visibleAppsCount = shownItemsCount || DEFAULT_VISIBLE_APPS_COUNT;
    const shownApps = isAllShown ? apps : apps.slice(0, visibleAppsCount);
    return {
        apps: shownApps,
        label: translate(labelKey || 'tvcomparison.apps'),
        count: apps.length,
        viewAllButton: apps.length > visibleAppsCount && {
            text: isAllShown ? translate('tvcomparison.showLess.label') : `${translate('tvcomparison.showAll.label')} (+${apps.length - visibleAppsCount})`,
            size: 'small',
            variant: 'secondary',
            onClick: async (event) => {
                await filterActions.toggleAllAppsShown(event);
                isAllShown && scrollToElement(shownApps[0].id);
            }
        }
    };
};
export const mapApps = (apps, commonProps) => {
    return apps === null || apps === void 0 ? void 0 : apps.map((app) => ({
        id: `app-${app.productOfferingCode}`,
        title: commonProps.translate(`tvcomparison.apps.${app.productOfferingCode}.label`),
        icon: `#${commonProps.getIcon(app.productOfferingCode)}`,
        iconStyle: app.productOfferingCode.includes(NETFLIX_IDENTIFIER) ? { color: NETFLIX_RED } : undefined,
        description: commonProps.translate(`tvcomparison.apps.${app.productOfferingCode}.description`),
        packetPrices: resolvePrices(app.prices, app.includedInPackage, commonProps, undefined, commonProps.translate(`tvcomparison.apps.${app.productOfferingCode}.label`), 'app').reverse()
    }));
};
export const filterApps = (apps, selectedApps) => {
    return apps.filter((app) => selectedApps.some((appIdentifier) => app.productOfferingCode.includes(appIdentifier)));
};
